import React from 'react'
import { useParams } from 'react-router-dom'
import { ChatsPage } from 'components/chats/ChatsPage'

export const SellerChats: React.FC = () => {
  const { id } = useParams<{ id: string }>()

  return <ChatsPage sellerId={id} readOnly />
}
